import { createAction, props } from '@ngrx/store';
import { User } from '@shared/models/user';

export const createUser = createAction('[Users] Create User', props<{ user: Partial<User> }>());

export const createUserSuccess = createAction('[Users] Create User Success', props<{ user: User }>());

export const createUserFailure = createAction('[Users] Create User Failure', props<{ error: any }>());
